export const testimonials = [
  {
    id: "t-1",
    name: "匿名用户 · 男性 · 35岁",
    content: "因为ED问题困扰了两年多，一直不敢去医院，怕被嘲笑。后来在妻子的鼓励下，我通过性事咨询员的线上咨询服务找到了方向。顾问非常专业，用科学的方式解释了问题的根源，帮我制定了循序渐进的改善方案。三个月后，情况有了明显改善，我和妻子的感情也比以前更好了。",
    rating: 5,
    service: "性功能困扰咨询",
  },
  {
    id: "t-2",
    name: "匿名用户 · 女性 · 29岁",
    content: "生完孩子后，我对性生活完全提不起兴趣，老公虽然理解但难免失落。咨询师帮我分析了产后激素变化和心理负荷的问题，还邀请我老公一起参与了两次伴侣咨询。现在我们的关系不仅恢复了，而且比以前更懂得如何沟通彼此的需求。",
    rating: 5,
    service: "亲密关系指导",
  },
  {
    id: "t-3",
    name: "匿名用户 · 男性 · 42岁",
    content: "和妻子结婚十五年，感觉两个人的距离越来越远。抱着试试看的心态预约了婚姻家庭咨询，没想到顾问一下子就点出了我们关系的核心问题。现在我们每周都留出专属的「约会时间」，感情确实在回暖。感谢性事咨询员的专业帮助。",
    rating: 5,
    service: "婚姻家庭咨询",
  },
  {
    id: "t-4",
    name: "匿名用户 · 女性 · 24岁",
    content: "因为小时候的一些经历，我一直对亲密接触有很大的恐惧。尝试过自己看书调整，但效果不明显。后来找到了性事咨询员的心理顾问，经过半年的咨询，我终于能够正视过去，也开始学习信任和接纳。这个过程很不容易，但每一次进步都让我更加喜欢现在的自己。",
    rating: 5,
    service: "性心理健康咨询",
  },
  {
    id: "t-5",
    name: "匿名用户 · 女性 · 38岁",
    content: "作为一个青春期女儿的妈妈，我一直不知道该怎么和她谈性教育的话题。青少年顾问给了我很多实用的建议，从选书到一起看纪录片，再到如何在自然场景下开启对话。现在女儿会主动和我分享她的困惑，这种信任让我特别感动。",
    rating: 5,
    service: "青春期性教育指导",
  },
  {
    id: "t-6",
    name: "匿名用户 · 男性 · 31岁",
    content: "因为工作压力和长期加班，我出现了严重的表现焦虑，越紧张越不行，越不行越紧张，陷入了恶性循环。顾问教我做了几个简单的正念练习，也帮我调整了对「完美表现」的不合理期待。其实很多时候，问题不在身体，而在心里。",
    rating: 5,
    service: "性心理健康咨询",
  },
];